import "./system.css";
import { useLocation, useNavigate } from "react-router-dom";
import ScrollIcon from "../../assets/images/icons/scroll.gif";
import SystemImage from "../../assets/images/systemImage1.png";
import SystemImage1 from "../../assets/images/systemImage2.png";
import ButtonClick from "../../assets/images/icons/Pulsante_sistemi.svg";
import GoOnIcon from "../../assets/images/icons/ambienti-freccia-home.svg";
import DiscoverIcon from "../../assets/images/icons/Icon-Scopri.svg";
import GoOnIcon2 from "../../assets/images/icons/ambienti-freccia-public.svg";
import SideMenu from "../_shared/components/SideMenu";
import { listOfPoints } from "./listOfPoints";
import AppText from "../_shared/components/AppText";
import { useEffect, useState } from "react";
import { Modal } from "antd";
import VideoSistemi from "../../assets/videos/animazione-sistema.mp4";
import CloseIcon from "../_shared/components/CloseIcon";

function System(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const location = useLocation();

  const [selectedVideo, setSelectedVideo] = useState();
  useEffect(() => {
    const element = document.getElementById(location.hash.replace("#", ""));

    if (element) {
      element.scrollIntoView({
        // behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  const [height, setHeight] = useState(2000);
  const [width, setWidth] = useState(2000);

  function setDimensions(img) {
    setHeight(img?.target?.offsetHeight);
    setWidth(img?.target?.offsetWidth);
  }

  function getTitleRowRooms(title, subTitle) {
    return (
      <div className="cardSystem" style={{ marginTop: 80 }}>
        <div className="row">
          <AppText big bold>
            {title}
          </AppText>
          <AppText big light>
            / {subTitle}
          </AppText>
        </div>
      </div>
    );
  }

  const navigate = useNavigate();
  function goTo(name) {
    switch (name) {
      case "contenitori":
        navigate("/StorageUnits");
        break;
      case "boiserie":
        navigate("/WallPanelling");
        break;
      case "armadi":
        navigate("/Wardrobes");
        break;
      case "cabine":
        navigate("/WalkInClosets");
        break;
      case "sistemaUniko":
        navigate("/UnikoSystem");
        break;
      case "librerie":
        navigate("/BookCases");
        break;
      default:
        return;
    }
  }

  return (
    <div>
      <div className="rootMenu">
        <SideMenu />
        <div className="rootContent">
          <div className="fullPage">
            <div style={{ height: "85vh" }}>
              <div style={styles.header}>
                <div style={{ marginBottom: 50 }}>
                  <AppText bold xbig>
                    Cinquanta3, il sistema
                  </AppText>
                  <AppText light xbig>
                    Cinquanta3, the system
                  </AppText>
                </div>
                <AppText small bold>
                  Un’ampia gamma di elementi d’arredo modulari, progettati per
                  organizzare in modo funzionale il quotidiano e moltiplicare,
                  con stile, lo spazio casa e gli spazi pubblici.
                </AppText>
                <AppText small old>
                  An extensive range of modular items of furniture, designed to
                  organize daily life in a functional way and multiply home
                  spaces stylishly.
                </AppText>
              </div>
            </div>
            <div
              className="row"
              style={{ justifyContent: "space-between", marginRight: 10 }}
            >
              <img
                src={ScrollIcon}
                className="arrow"
                style={{ marginLeft: "45%" }}
                alt=""
              ></img>
              <div
                className="row"
                style={{ cursor: "pointer" }}
                onClick={() => setSelectedVideo(true)}
              >
                <img
                  src={DiscoverIcon}
                  alt=""
                  style={{
                    height: 30,
                    width: 30,
                    marginRight: 10,
                    textDecorationLine: "underline",
                  }}
                ></img>
                <AppText
                  small
                  bold
                  style={{
                    display: "flex",
                    height: 30,
                    alignItems: "center",
                  }}
                >
                  scopri
                </AppText>
                <AppText
                  style={{
                    display: "flex",
                    height: 30,
                    alignItems: "center",
                  }}
                  small
                >
                  / discover
                </AppText>
              </div>
            </div>
          </div>
          <div
            className="fullPageImage"
            style={{ marginTop: 100, marginBottom: 100 }}
          >
            <img src={SystemImage} style={{ width: "100%" }} alt="img"></img>
            {listOfPoints.map((point) => (
              <div
                style={{
                  position: "absolute",
                  top: `${point?.top}%`,
                  left: `${point?.left}%`,
                }}
              >
                <img
                  className="animate-pulse"
                  src={ButtonClick}
                  style={{ height: 30, width: 30, cursor: "pointer" }}
                  alt="img"
                  onClick={() => goTo(point.name)}
                ></img>
              </div>
            ))}
          </div>
          <div className="fullPage">
            {getTitleRowRooms("Ambienti", "Rooms")}
            <div style={{ maxWidth: "60%", marginLeft: 80, marginBottom: 20 }}>
              <AppText small bold>
                Esplora gli ambienti Home e Public di Cinquanta3. Qui trovi i
                nostri progetti: dagli spazi a misura di quotidiano per la casa,
                a quelli flessibili e funzionali pensati per il pubblico. La
                scoperta di nuovi luoghi a portata di mano, in un solo click.
              </AppText>
              <AppText small>
                Explore Cinquanta3's Home and Public interiors. This is where
                you'll find our designs: from spaces tailored to daily life for
                the home, to flexible, functional spaces designed for public
                use. A journey of discovery into new places is just a click
                away.
              </AppText>
            </div>
            <div
              style={{
                marginLeft: 80,
                maxHeight: "90vh",
                aspectRatio: 16 / 9,
                position: "relative",
                backgroundImage: `url(${SystemImage1})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
              }}
            >
              {/* homeSpaces div */}
              <div
                style={{
                  position: "absolute",
                  maxWidth: "35%",

                  top: 30,
                  paddingLeft: "5%",
                  cursor: "pointer",

                  height: "100%",
                }}
                onClick={() => navigate(`/home-spaces`)}
              >
                <div className="row" style={{ marginBottom: 40 }}>
                  <AppText xbig bold style={{ color: "#4f4a34" }}>
                    home spaces
                  </AppText>
                  <img
                    src={GoOnIcon2}
                    style={styles.icon}
                    alt=""
                    className="animate-pulse"
                  ></img>
                </div>
              </div>
              {/* publicSpaces div */}
              <div
                style={{
                  position: "absolute",
                  maxWidth: "35%",

                  top: 30,
                  height: "100%",
                  marginLeft: "55%",

                  paddingRight: "5%",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/public-spaces`)}
              >
                <div
                  className="row"
                  style={{
                    position: "relative",
                    marginBottom: 40,
                  }}
                >
                  <AppText xbig bold style={{ color: "#d69a28" }}>
                    public spaces
                  </AppText>
                  <img
                    src={GoOnIcon}
                    style={styles.icon}
                    alt=""
                    className="animate-pulse"
                  ></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={selectedVideo}
        closable={false}
        footer={[]}
        centered
        bodyStyle={{ height: "80vh", overflowY: "auto" }}
        className="modal"
      >
        <div style={{ marginLeft: "97%", marginBottom: 15 }}>
          <CloseIcon onClick={() => setSelectedVideo(false)}></CloseIcon>
        </div>
        <video
          autoPlay
          restart
          src={VideoSistemi}
          width="100%"
          height="90%"
          controls
        />
      </Modal>
    </div>
  );
}
const styles = {
  header: {
    marginTop: "3%",
    marginLeft: 80,
    maxWidth: "50%",
  },

  titleHome: {},
  sectionStyle: {
    marginLeft: 80,
    height: "90vh",
    maxWidth: "85vw",

    position: "relative",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  icon: {
    marginTop: 10,
    height: 20,
    width: 20,
  },
  homeSpaces: {
    paddingLeft: "5%",
    paddingRight: "5%",

    maxWidth: "40%",
    height: "85vh",
  },
};

export default System;
